import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { useCan } from '@/core/auth/use-can';

interface AdminRouteProps {
    children: ReactNode;
}

export function AdminRoute({ children }: Readonly<AdminRouteProps>) {
    const isAdmin = useCan('app', 'manage');

    if (!isAdmin) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
}
